<template>
  <div class="adminWebsiteConfig">
    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>运营配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="PageContent">
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="今日网价" name="price">
          <MarketPriceConfig v-if="activeTab == 'price'" key="price" />
        </el-tab-pane>

        <el-tab-pane label="热搜词" name="hotword">
          <el-tabs v-model="subTab_hotword" tab-position="left">
            <el-tab-pane :label="l('现货卖场')" name="quotation">
              <HotwordConfig
                v-if="subTab_hotword == 'quotation'"
                key="quotation"
                name="quotation"
              />
            </el-tab-pane>
            <el-tab-pane :label="l('锻件定制')" name="purchase_forging">
              <HotwordConfig
                v-if="subTab_hotword == 'purchase_forging'"
                key="purchase_forging"
                name="purchase_forging"
              />
            </el-tab-pane>
            <el-tab-pane :label="l('原料求购')" name="purchase_material">
              <HotwordConfig
                v-if="subTab_hotword == 'purchase_material'"
                key="purchase_material"
                name="purchase_material"
              />
            </el-tab-pane>

            <el-tab-pane :label="l('钢厂拼单')" name="raise">
              <HotwordConfig
                v-if="subTab_hotword == 'raise'"
                key="raise"
                name="raise"
              />
            </el-tab-pane>
            <el-tab-pane label="零切交易" name="purchase_piece">
              <HotwordConfig
                v-if="subTab_hotword == 'purchase_piece'"
                key="purchase_piece"
                name="purchase_piece"
              />
            </el-tab-pane>

            <el-tab-pane label="论坛" name="forum">
              <HotwordConfig
                v-if="subTab_hotword == 'forum'"
                key="forum"
                name="forum"
              />
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import HotwordConfig from "./tabs/HotwordConfig.vue";
import MarketPriceConfig from "./tabs/MarketPriceConfig.vue";
export default {
  name: "AdminWebsiteConfig",
  components: {
    HotwordConfig,
    MarketPriceConfig,
  },
  data() {
    return {
      activeTab: "price",
      subTab_hotword: "quotation",
    };
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
//el-tabs选中标签加粗
/deep/.el-tabs__item.is-active {
  font-weight: bold;
  // color: $warningColor;
}
</style>

